import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { useDataContext } from '../context/data';
import { useOrderContext } from '../context/order';
import translations from '../constants/translations.json';
import { SESSION_EXPIRED_EVENT } from '../utils/authSession';

// Headless. utils/authSession drops a session the backend has rejected — a
// retired pre-refresh-token login, or a revoked refresh token — and fires
// SESSION_EXPIRED_EVENT. This is the UI half: stop looking signed in, say why,
// and offer the login modal, instead of leaving the user with a navbar that
// says they are logged in while every request fails.
//
// Mounted inside all the providers (index.js) rather than in Navbar, so it
// still works on the routes that render without a navbar.
export default function SessionExpiryWatcher() {
  const { setUserProfile, language } = useDataContext() || {};
  const orderContext = useOrderContext();

  // The contexts hand back a fresh object every render; read them through a ref
  // so the listener is attached once instead of re-subscribing constantly.
  const latest = useRef(null);
  latest.current = { setUserProfile, language, orderContext };

  useEffect(() => {
    const onSessionExpired = () => {
      const current = latest.current || {};
      current.setUserProfile?.({});
      toast.info(
        translations[current.language]?.session_expired_message ||
          translations.en.session_expired_message,
      );
      current.orderContext?.setLoginModal?.(true);
    };

    window.addEventListener(SESSION_EXPIRED_EVENT, onSessionExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onSessionExpired);
  }, []);

  return null;
}
